import Vue from 'vue';
import App from './app';
import router from './router';
import store from './store';
import question from '@/components/question'

// 注册全局组件
Vue.component('question', question)

//Axios
import axios from './utils/http';
Vue.prototype.$http = axios; // 通过修改原型链，来更方便的使用

// JsonP
import VueJsonp from 'vue-jsonp';
Vue.use(VueJsonp);

// md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

//Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { size: 'mini' });

import introJS from 'intro.js';
import 'intro.js/introjs.css';
Vue.prototype.$intro = introJS;

//moment 日期插件
import moment from 'moment';
Vue.prototype.$moment = moment;

// 自定义滚动条
import vuescroll from 'vuescroll/dist/vuescroll-native';
import 'vuescroll/dist/vuescroll.css';
Vue.use(vuescroll);

import VueCropper from 'vue-cropper'; // 图片裁剪
Vue.use(VueCropper);

//引入外部资源
import './assets/css/reset.css'; // css reset
import './assets/css/element-ui.css'; // elementUI 组件样式覆盖
import '@/assets/css/public.css'; // 公用样式
import './assets/iconfont/iconfont.css'; // 阿里巴巴图标库

// 权限控制
import './permission';

// Vue.prototype.$echo = echo;

Vue.config.productionTip = false; // 设置为 false 以阻止 vue 在启动时生成生产提示
// Vue.config.silent = true; // 取消 Vue 所有的日志与警告

new Vue({
    el: '#App',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js